import { render } from "./OrderWechatPay.vue?vue&type=template&id=4458ab06&scoped=true"
import script from "./OrderWechatPay.vue?vue&type=script&lang=js"
export * from "./OrderWechatPay.vue?vue&type=script&lang=js"

import "./OrderWechatPay.vue?vue&type=style&index=0&id=4458ab06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4458ab06"]])

export default __exports__